import type { AiStatus, CaptureStatus } from "./transcription-status";
import type { RecordingPhase, TranscriptionMachineState } from "./types";

export type MachineStateInput = {
  isOpen: boolean;
  hasSession: boolean;
  recordingPhase: RecordingPhase;
  isStarting: boolean;
  isFinalizing: boolean;
  isInterrupted: boolean;
  captureStatus: CaptureStatus | null;
  aiStatus: AiStatus | null;
  hasCaptureError: boolean;
};

/**
 * Ordem de precedencia importa: `isFinalizing` e definido de forma sincrona no clique
 * de encerrar, entao ele vence qualquer `recordingPhase` que o SDK ainda nao atualizou.
 */
export const resolveMachineState = ({
  isOpen,
  hasSession,
  recordingPhase,
  isStarting,
  isFinalizing,
  isInterrupted,
  captureStatus,
  aiStatus,
}: MachineStateInput): TranscriptionMachineState => {
  if (!isOpen || !hasSession) return "closed";
  if (isFinalizing) return "finalizing";
  if (isInterrupted) return "interrupted";

  if (captureStatus === "finalized") {
    if (aiStatus === "processing") return "analyzing";
    if (aiStatus === "error") return "analysis_failed";
    return "ready";
  }

  if (isStarting || recordingPhase === "recording") return "recording";
  if (recordingPhase === "paused") return "paused";

  return "draft";
};

export const isTimerRunning = (state: TranscriptionMachineState): boolean => state === "recording";
